import {
  Controller,
  ControllerRenderProps,
  FieldValues,
  useFormContext
} from "react-hook-form";
import { InputBaseParams } from "../Form";

export const CheckboxElement = ({
  label,
  value,
  name,
  className,
  checkboxClassName,
  onChange,
  onBlur
}: Omit<ControllerRenderProps<FieldValues, string>, "ref"> & {
  label?: string;
  className?: string;
  checkboxClassName?: string;
}) => (
  <div className={"gap flex items-center gap-3 " + className}>
    <input
      id={name}
      type="checkbox"
      checked={!!value}
      className={"border-ctb-grey-600 " + checkboxClassName}
      onChange={e => onChange(e.target.checked)}
      onBlur={onBlur}
    />
    <label className="p-0" htmlFor={name}>
      {label}
    </label>
  </div>
);

/**
 * A controlled checkbox.
 *
 * @param className Applies styling to the overall checkbox and label container
 * @param checkboxClassName Applies styling to the actual checkbox input directly
 */
const Checkbox = ({
  name,
  label,
  rules,
  className,
  checkboxClassName
}: InputBaseParams & {
  label?: string;
  className?: string;
  checkboxClassName?: string;
}) => {
  const { control } = useFormContext();

  return (
    <>
      <Controller
        name={name}
        rules={rules}
        control={control}
        render={({ field: { name, value, onChange, onBlur } }) => (
          <CheckboxElement
            name={name}
            className={className}
            checkboxClassName={checkboxClassName}
            label={label}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
          />
        )}
      />
    </>
  );
};

export default Checkbox;
